<template>
  <div class="diary-view">
    <h2>日记</h2>
    <el-empty description="暂无日记内容，敬请期待..." />
  </div>
</template>

<script>
export default {
  name: 'DiaryView'
};
</script>

<style scoped>
.diary-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
}
</style> 